import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { ProcessDesign } from './process-design';
export { ProcessDesign };
import { processDesignSchema } from '@schemas/business-objects/process-design';
import { ProcessDesignActivityCountFormArray } from './process-design-activity-count-form-group';
import { ProcessDesignHistoryFormArray } from './process-design-history-form-group';
import { ProcessInstanceFormArray } from './process-instance-form-group';

export class ProcessDesignFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    designUuid: SchemaFormControl;
    name: SchemaFormControl;
    displayName: SchemaFormControl;
    description: SchemaFormControl;
    version: SchemaFormControl;
    suspended: SchemaFormControl;
    sha1Sum: SchemaFormControl;
    designJson: SchemaFormControl;
    analysis: SchemaFormControl;
    createdAt: SchemaFormControl;
    updatedAt: SchemaFormControl;
    processInstances: ProcessInstanceFormArray;
    processDesignHistories: ProcessDesignHistoryFormArray;
    processDesignActivityCounts: ProcessDesignActivityCountFormArray;
  };

  declare value: Partial<ProcessDesign>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(processDesignSchema, ProcessDesign, data, options);
  }

  get object(): ProcessDesign {
    return new ProcessDesign(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'processInstances':
        return new ProcessInstanceFormArray();
      case 'processDesignHistories':
        return new ProcessDesignHistoryFormArray();
      case 'processDesignActivityCounts':
        return new ProcessDesignActivityCountFormArray();
      default:
        return undefined;
    }
  }

  async suspend(): Promise<any> {
    const instance = new ProcessDesign(this.value);
    return instance.suspend();
  }

  async reanalyze(): Promise<any> {
    const instance = new ProcessDesign(this.value);
    return instance.reanalyze();
  }

  async activate(): Promise<any> {
    const instance = new ProcessDesign(this.value);
    return instance.activate();
  }
}

export class ProcessDesignFormArray extends PersistedFormArray {
  readonly entityName = 'ProcessDesign' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(processDesignSchema, ProcessDesign, options);
  }

  protected override createItemGroup() {
    return new ProcessDesignFormGroup();
  }

  get array(): ProcessDesign[] {
    return this.controls.map((group: ProcessDesignFormGroup) => group.object);
  }
}

export class ProcessDesignPersistedArray extends PersistedArray<ProcessDesign> {
  readonly entityName = 'ProcessDesign' as const;

  constructor(options?: PersistedArrayOptions) {
    super(ProcessDesign, options);
  }
}
